import { useContext } from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material"
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { Smartphone, Computer} from '@mui/icons-material';
import Content from "./Content";
import { Design } from "./Design";
import { Details } from "./Details";
import { ToolContext } from "../../../../../../core/context/ToolContext";

export const Tabs = () => {
    const { marketing_camp } = useContext(ToolContext)
    const { trngTabsErr, trngForm } = marketing_camp 
    const urlParams = new URLSearchParams(window.location.search)
    const nav = useHistory()

    const handlerTabs = (step) => {
        if (urlParams.get('id')) {
            nav.push(`?id=${urlParams.get('id')}&step=${step}`)
        } else if (urlParams.get('pid')) {
            nav.push(`?pid=${urlParams.get('pid')}&step=${step}`)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        const updatedForm = { 
            ...trngForm.data, 
            [name]: { 
                ...trngForm.data[name], 
                value, 
                stat: value.trim() === '' 
            } 
        }
        trngForm.set(updatedForm)
        validateFields(updatedForm)
    }

    const validateFields = (data) => {
        const form = structuredClone(data);
		let tabErrors = { content: false, details: false, tabs: false };
        const required = ["dis_and_ins", "speakers", "heading", "sub_heading", "title", "button", "time", "date", "location", "poster_name", ];
        required.forEach(v => {
            const field = form[v];
            if (v === 'dis_and_ins') {
                const textOnly = field.value.replace(/<[^>]*>/g, '').trim();
                tabErrors.content = !textOnly;
                tabErrors.tabs = !textOnly;
            } else if (v === 'speakers') {
                field.forEach((spkr, i) => {
                    ['name', 'description', 'company'].forEach((f) => {
                        if (spkr[f].value.trim() === "") {
                            tabErrors.content = tabErrors.content || spkr[f].value.trim() === "";
                            tabErrors.tabs = tabErrors.tabs || spkr[f].value.trim() === "";
                        }
                    })
                })
            } else {
                if (v === 'poster_name') {
                    tabErrors.details = field.value.trim() === "";
                } else {
                    tabErrors.content = tabErrors.content || field.value.trim() === "";
                }
                tabErrors.tabs = tabErrors.tabs || field.value.trim() === "";
            }
        })
        trngTabsErr.set(p => ({ ...p, ...tabErrors }));
    } 

    return (
        <Box display="flex" flexDirection="column" height="100%" className="overflowY" sx={{ borderRight: '2px solid #F7F8F8' }}>
            <Box display="flex" justifyContent="space-around" p="16px" sx={{ borderBottom: '2px solid #F7F8F8' }}>
                <Box component={Button} px='24px' variant="outlined" onClick={() => handlerTabs('content')}
                    bgcolor={urlParams.get('step') === 'content' ? "#C3D7C3" : "#fff"} color="#003022"
                    sx={{ border: `1px solid ${trngTabsErr.data.content ? '#B6174B' : '#ACC6B1' }`, borderRadius: '6px', fontSize: '14px', fontWeight: '600', ':hover': {bgcolor: urlParams.get('step') === 'content' ? "#ACC6B1" : "#fff", border: '1px solid #ACC6B1' } }}>
                    Content
                </Box>
                <Box component={Button} px='24px' variant="outlined" onClick={() => handlerTabs('design')}
                    bgcolor={urlParams.get('step') === 'design' ? "#C3D7C3" : "#fff"} color="#003022"
                    sx={{ border: '1px solid #ACC6B1', borderRadius: '6px', fontSize: '14px', fontWeight: '600', ':hover': {bgcolor: urlParams.get('step') === 'design' ? "#ACC6B1" : "#fff", border: '1px solid #ACC6B1' } }}>
                    Design
                </Box>
                <Box component={Button} px='24px' variant="outlined" onClick={() => handlerTabs('details')}
                    bgcolor={urlParams.get('step') === 'details' ? "#C3D7C3" : "#fff"} color="#003022"
                    sx={{ border: `1px solid ${trngTabsErr.data.details ? '#B6174B' : '#ACC6B1' }`, borderRadius: '6px', fontSize: '14px', fontWeight: '600', ':hover': {bgcolor: urlParams.get('step') === 'details' ? "#ACC6B1" : "#fff",border: '1px solid #ACC6B1' } }}>
                    Details
                </Box>
            </Box>
            <Box display="flex" flexDirection="column" p="16px" height="100%" className="overflowY">
                {
                    urlParams.get('step') === 'content' ?
                        <Content handleChange={handleChange} validateFields={validateFields}/>
                    :   
                        urlParams.get('step') === 'design' ?
                            <Design/>
                        :
                            urlParams.get('step') === 'details' ?
                                <Details handleChange={handleChange}/>
                            :
                                <Box> 
                                    404
                                </Box>
                }
            </Box>
            <Box p="16px" bgcolor="#ffffff" sx={{ borderTop: '2px solid #F7F8F8' }} >
                <Box display="flex" gap="16px">
                    <IconButton sx={{border: '1px solid #1976d2', borderRadius: 1}}>
                        <Smartphone sx={{color: '#1976d2'}} />
                    </IconButton>
                    <Tooltip title="This is not available" arrow>
                        <IconButton>
                            <Computer />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
        </Box>
    )
}
